const titles = document.querySelectorAll('.collapsible-content__heading');
const linklist = document.querySelectorAll('.faq-section-tablinks ul li a');
const titleList = [];

titles.forEach((element, index) => {
    titleList.push(element.getAttribute('data-link'))
    element.setAttribute('id', `tab${index}`)
});





function makeUL(array) {
    // Create the list element:
    let list = document.createElement('ul');

    for (let i = 0; i < array.length; i++) {
        // Create the list item:
        let item = document.createElement('li');
        let link = document.createElement('a');
        link.setAttribute('href', `#tab${i}`)
        link.appendChild(document.createTextNode(array[i]))
        // Set its contents:
        item.appendChild(link);

        // Add it to the list:
        list.appendChild(item);
    }

    // Finally, return the constructed list:
    return list;
}

// Add the contents of options[0] to #foo:
document.getElementById('faq_links').appendChild(makeUL(titleList));

document.querySelectorAll(".faq-section-tablinks ul li a")[0].classList.add("active");
// Define selector for selecting
// anchor links with the hash
let anchorSelector = '.faq-section-tablinks ul li a[href^="#"]';

// Collect all such anchor links
let anchorList =
    document.querySelectorAll(anchorSelector);

// Iterate through each of the links
anchorList.forEach(link => {
    link.onclick = function (e) {

        // Prevent scrolling if the
        // hash value is blank
        e.preventDefault();
        document.querySelector('.faq-section-tablinks ul li a.active').classList.remove('active');
        e.target.classList.add('active');
        // Get the destination to scroll to
        // using the hash property
        let destination =
            document.querySelector(this.hash);
        destination.scrollIntoView({
            behavior: 'smooth'
        });
    }
});